export class ResponseCartao {

    private id: number;
    private uuid: string;
    private numero: string;
    private documentoValido: boolean;

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getUuid(): string {
        return this.uuid;
    }

    public setUuid(uuid: string): void {
        this.uuid = uuid;
    }

    public getNumero(): string {
        return this.numero;
    }

    public setNumero(numero: string): void {
        this.numero = numero;
    }

    public isDocumentoValido(): boolean {
        return this.documentoValido;
    }

    public setDocumentoValido(documentoValido: boolean): void {
        this.documentoValido = documentoValido;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/responseCartao.ts